const InitialState = {
	machineID: "",
	location: "",
	kitchenId: "",
};

export const landing = (state = InitialState, action) => {
	switch (action.type) {
		case "SET_MACHINE_ID":
			return {
				...state,
				machineID: action.data._id,
				location: action.data.name,
				kitchenId: action.data.kitchenId,
			};

		default:
			return {
				...state,
			};
	}
};

export default landing;
